"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DropdownItemCustom = _interopRequireDefault(require("./DropdownItemCustom"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * A Dropdown item that contains a Checkbox Custom Control.
 */
const DropdownItemCheckbox = _DropdownItemCustom.default.bind({}, 'checkbox');
DropdownItemCheckbox.propTypes = {
  /** Secondary label that follows the item's children. */
  caption: _propTypes.default.string,
  /** Should the checkbox be checked by default? */
  defaultChecked: _propTypes.default.bool,
  /** The identifier of the form control. */
  id: _propTypes.default.string.isRequired,
  /** The name of the form control */
  name: _propTypes.default.string.isRequired,
  /** The event listener/handler for the click event. */
  onClick: _propTypes.default.func
};
DropdownItemCheckbox.displayName = 'Dropdown.CheckboxItem';
DropdownItemCheckbox.defaultProps = {
  defaultChecked: false
};
var _default = exports.default = DropdownItemCheckbox;